import styled, { css } from 'styled-components';

import { Modal, Typography } from '@speeki/global-ui-components';

export const SelectOptionTitle = styled(Typography.TextBody_14_20)`
    margin: 16px 0 10px 0;
`;

export const CustomDescription = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
        margin-bottom: 24px;

        p {
            font-size: 16px;
            line-height: 24px;
            margin: 0;
        }
    `,
);

export const ModalDescription = styled(Modal.Description)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
        margin-bottom: 24px;
    `,
);
